export default "https://cdn-static.gokick.com/assets/24c3578bda803cdf114b208e53f44151315faa60/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";